import React from 'react';
import Loader from '@/components/atoms/Loader';
import { Module, ModuleNepting, ModuleTpe } from '@/services/innovorder/modules/modules.type';
import { Brand } from '@/services/innovorder/brand/brand.type';
import { ChannelId } from '@/services/innovorder/channel/channel.type';
import { IOPayConfig } from '@/services/innovorder/io-pay/configurations/configurations.type';
import { EdenredConfig } from '@/services/innovorder/edenred/configurations/configurations.type';
import { PaymentMethodWebTab as Tab } from './Web.tab';
import { usePaymentMethods } from '@/hooks/usePaymentMethods';
import { CrousModuleResponse } from '@/services/innovorder/moduleCrous/moduleCrous.type';

export type WebProps = {
    channelId: ChannelId;
    restaurantId: string;
    brand?: Brand;
    ingenicoConfig?: Module;
    neptingConfig?: ModuleNepting;
    stripeConfig?: Module;
    ioPayConfig?: IOPayConfig;
    edenredConfig?: EdenredConfig;
    paygreenConfig?: Module;
    crousConfig?: CrousModuleResponse;
    ingenicoTpeList?: ModuleTpe[];
};

const PaymentMethodWebTab: React.FunctionComponent<React.PropsWithChildren<WebProps>> = ({
    channelId,
    restaurantId,
    brand,
    stripeConfig,
    ioPayConfig,
    edenredConfig,
    paygreenConfig,
    crousConfig,
}) => {
    const {
        isLoading,
        paymentMethods,
        isLoadingConsumptionModes,
        consumptionModes,
        isLoadingSave,
        onChange,
        onSave,
        resetPaymentMethods,
    } = usePaymentMethods(channelId, restaurantId, brand?.brandId);

    if (isLoading) {
        return <Loader withContainer />;
    }

    return (
        <Tab
            stripeConfig={stripeConfig}
            ioPayConfig={ioPayConfig}
            edenredConfig={edenredConfig}
            paygreenConfig={paygreenConfig}
            crousConfig={crousConfig}
            channelId={channelId}
            brand={brand}
            isLoadingConsumptionModes={isLoadingConsumptionModes}
            paymentMethods={paymentMethods}
            consumptionModes={consumptionModes}
            isLoadingSave={isLoadingSave}
            onChange={onChange}
            onSave={onSave}
            onCancel={resetPaymentMethods}
        />
    );
};

export { PaymentMethodWebTab };
